export enum statuses {
    Create = 'Create',
    Update = 'Update',
    Delete = 'Delete',
    Notifications = 'Notifications',
    FullSync = 'FullSync',
    MeteringSync = 'MeteringSync',
    ServiceAvailabilitySync = 'ServiceAvailabilitySync'
}

export const WSTypes = {
    cluster: 'clusters',
    tenant: 'tenants',
    region: 'regions',
    site: 'sites',
    device: 'devices',
    link: 'links',
    group: 'groups',
    service: 'services',
    customer: 'lcCustomers',
    channel: 'channels',
    arm: 'externalApplications',
    masterscope: 'externalApplications',
    voca: 'externalApplications',
    zoompeering: 'externalApplications',
    meetingInsights: 'externalApplications',
    interactionRecording: 'externalApplications'
} as const;

export type WSServerType = keyof typeof WSTypes;
export type WSClientType = typeof WSTypes[keyof typeof WSTypes];

export class WSMessage {
    static readonly wsObjects = WSTypes;

    name: string;
    protocol: string;
    description: string;
    status: string;
    messageType: statuses;
    module: string;
    arrivalTime: number;
    entities: any[];
    entitiesIds: any[];
    entityType: string;
    entityTypeName: string;

    constructor() {
        this.arrivalTime = Date.now();
    }

    wsEntityTypeMapper = (entityType: string) => {
        if(!entityType){
            return ;
        }

        return WSTypes[entityType.toLowerCase()];
    }

    prepareMessage = () => {
        this.entityTypeName = this.wsEntityTypeMapper(this.entityType);
        if (this.entities) {
            this.entitiesIds = this.entities.map((entity) => entity.entityId);
        }
    };
}
